import { MbbProduct } from '../models/mbb-product.model';
import { Subscriber } from '@shared/models/subscriber.model';
import { Subscription } from '@shared/models/subscription-model';
import { AssignedSubscriptionModel } from '@shared/models/assigned-subscription-offering.model';
import { MbbAllowedChangeInfo } from '../models/mbb-offerings-response.model';
import { PaymentType } from '@shared/enums/payment-type';
import { MbbDeliveryOptions } from '../models/mbb-delivery-options.model';

export class MbbProductAddAction {
  public static readonly type = '[MBB Product] Add mbb product';
  constructor(public product: MbbProduct) {}
}

export class MbbProductSubscriberUpdateAction {
  public static readonly type = '[MBB Product] Update product subscriber';
  constructor(
    public productId: string,
    public subscriber: Subscriber
  ) {}
}

export class MbbProductUpdateAction {
  public static readonly type = '[MBB Product] Update mbb product';
  constructor(public product: MbbProduct) {}
}

export class UpdateMbbRouterDetailsAction {
  public static readonly type = '[MBB Product] Update mbb router details';
  constructor(
    public productId: string,
    public icc: string,
    public imei: string,
    public routerName: string
  ) {}
}

export class MbbProductRemoveConfirmAction {
  public static readonly type = '[MBB Product] Confirm remove mbb product';
  constructor(public productId: string) {}
}

export class MbbProductResetAction {
  public static readonly type = '[MBB Product] Reset mbb product state';
}

export class UpdateMbbDeliveryOptionAction {
  public static readonly type = '[MBB Product] Update delivery option';
  constructor(
    public productId: string,
    public deliveryOption: MbbDeliveryOptions
  ) {}
}

export class SetExistingMbbSubscriptionsAction {
  static readonly type = '[MBB Product] Set existing mbb subscriptions';
  constructor(public mbbSubscriptions: Subscription[]) {}
}

export class SetPaymentTypeOnMBBAction {
  public static readonly type = '[MBB Product] Set payment Type';
  constructor(
    public productId: string,
    public paymentType: PaymentType
  ) {}
}

export class SetAssignedMbbSubscriptionAction {
  static readonly type = '[MBB Product] Set assigned mbb subscriptions';
  constructor(public assignedSubscription: AssignedSubscriptionModel) {}
}

export class ApiGetAssignedMbbSubscriptionsAction {
  public static readonly type = '[Api] Get assigned mbb subscriptions ';
  constructor(public subscriptionIds: string[]) {}
}

export class ApiGetAssignedMbbSubscriptionsSuccessAction {
  static readonly type = '[Api] Get assigned mbb subscriptions success';
  constructor(public assignedSubscriptions: AssignedSubscriptionModel[]) {}
}

export class ApiGetAssignedMbbSubscriptionsErrorAction {
  static readonly type = '[Api] Get assigned mbb subscriptions Error';
}

export class ApiGetMbbSubscriptionOfferingsAction {
  public static readonly type = '[API] Get Mbb subscription offerings';
  constructor(public subscriptionId: string) {}
}

export class ApiGetMbbSubscriptionOfferingsSuccessAction {
  public static readonly type = '[API] Get Mbb subscription offerings success';
  constructor(
    public subscriptionId: string,
    public offerings: MbbAllowedChangeInfo[]
  ) {}
}

export class ApiGetMbbSubscriptionOfferingsErrorAction {
  public static readonly type = '[API] Get Mbb subscription offerings error';
  constructor(
    public subscriptionId: string,
    public error: string
  ) {}
}

export class ToggleSelectedMbbSubscriptionAction {
  public static readonly type = '[MBB Subscription] Toggle selected subscription';
  constructor(public id: string) {}
}

export class SetSelectedMbbSubscriptionIdAction {
  public static readonly type = '[MBB Subscription] Set selected subscription id';
  constructor(public id: string) {}
}

export class SetSelectedMbbStepIndexAction {
  public static readonly type = '[MBB Subscription] Set selected step index';
  constructor(public index: number) {}
}

export class ResetSelectedMbbSubscriptionAction {
  public static readonly type = '[MBB Subscription] Reset selected subscription';
}
